import Link from 'next/link';

import { css } from '@flipster/styled-system/css';
import { linkOverlay } from '@flipster/styled-system/patterns';

import { RelatedArticleType } from '@web/app/[locale]/glossary/[term]/_page/jotai';

const TypenamePathMapper = {
  GlossaryTerm: '/glossary/',
  BlogPost: '/blog/',
};

const RelatedArticle = ({ article }: { article: RelatedArticleType }) => {
  return (
    <article
      className={css({
        position: 'relative',
        h: '100%',
        p: [20, '24px 32px'],
        bgColor: 'background.default.level-1',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'border.default.level-1',
        borderRadius: 16,
      })}
    >
      <h3 className={css({ textStyle: 'Title/M', color: 'content.default.level-5', mb: 16 })}>
        {article.__typename === 'GlossaryTerm' && article.name}
        {article.__typename === 'BlogPost' && article.title}
      </h3>
      <p
        className={css({
          textStyle: 'Text/L/Regular',
          color: 'content.default.level-3',
          overflow: 'hidden',
          display: '-webkit-box',
          boxOrient: 'vertical',
          lineClamp: [5, 2, 3],
        })}
      >
        {article.summary}
      </p>
      <Link
        href={TypenamePathMapper[article.__typename] + article.slug}
        className={linkOverlay()}
        aria-hidden
        tabIndex={-1}
      />
    </article>
  );
};

export default RelatedArticle;
